import {
  CONTOSO_COPILOT_PROD,
  CONTOSO_COPILOT_PROD_HARDCODED,
  CONTOSO_COPILOT_WITH_DASH,
  CONTOSO_COPILOT_WITH_WEBSOCKET,
  FSI_DEMOS,
} from "common";
import { Menu } from "types";

export const getMenu = (demoId: string) => {
  if (demoId === CONTOSO_COPILOT_PROD) {
    return [
      {
        id: 11,
        menuName: "Shopping Copilot Prod",
        menuIcon: "Shopping_Copilot_Icon.png",
        href: `/${demoId}/shopping-copilot`,
      },
      {
        id: 2,
        menuName: "Azure OpenAI Chatbot for Enterprise Data",
        menuIcon: "GM menu item 1.png",
        href: `/${demoId}/chat-bot`,
      },
      {
        id: 12,
        menuName: "Shopping Copilot HardCoded",
        menuIcon: "Shopping_Copilot_Icon.png",
        href: `/${demoId}/shopping-copilot-new`,
      },
      {
        id: 3,
        menuName: "Social Media Campaign & Product Recommendation",
        menuIcon: "GM menu item 2.png",
        href: `/${demoId}/social-media-campaign`,
      },
      {
        id: 4,
        menuName: "Azure OpenAI with Speech Service",
        menuIcon: "GM menu item 3.png",
        menuItems: [
          {
            id: 5,
            icon: "icon11_4.png",
            title: "Call Center Report Before - Summary",
            href: `/${demoId}/call-center-before-summary`,
          },
          {
            id: 6,
            icon: "icon11_4.png",
            title: "Call Center Report Before - Script",
            href: `/${demoId}/call-center-before-script`,
          },
          {
            id: 7,
            icon: "icon_video.png",
            title: "Customer Conversation",
            href: `/${demoId}/customer-conversation`,
          },
          {
            id: 8,
            icon: "GM menu item 3.png",
            title: "Call Center - Generate Summary",
            href: `/${demoId}/call-center`,
          },
          {
            id: 9,
            icon: "icon11_4.png",
            title: "Call Center Report After - Script",
            href: `/${demoId}/call-center-after-script`,
          },
          {
            id: 10,
            icon: "icon11_4.png",
            title: "Call Center Report After - Summary",
            href: `/${demoId}/call-center-after-summary`,
          },
        ],
      },
      {
        id: 16,
        menuName: "Shopping Copilot Cosmos",
        menuIcon: "Shopping_Copilot_Icon.png",
        href: `/${demoId}/shopping-copilot-cosmos`,
      },
      {
        id: 20,
        menuName: "Azure OpenAI Chatbot for Enterprise Data UAT",
        menuIcon: "GM menu item 1.png",
        href: `/${demoId}/chat-bot-2`,
      },
      {
        id: 16,
        menuName: "Shopping Copilot UAT",
        menuIcon: "Shopping_Copilot_Icon.png",
        href: `/${demoId}/shopping-copilot-uat`,
      },

      {
        id: 16,
        menuName: "Shopping Copilot MTC/EBC Demo",
        menuIcon: "Shopping_Copilot_Icon.png",
        href: `/${demoId}/shopping-copilot-mtc`,
      },
    ] as Menu[];
  } else if (demoId === CONTOSO_COPILOT_WITH_WEBSOCKET) {
    return [
      {
        id: 11,
        menuName: "Shopping Copilot",
        menuIcon: "Shopping_Copilot_Icon.png",
        href: `/${demoId}/shopping-copilot`,
      },
      {
        id: 2,
        menuName: "Azure OpenAI Chatbot for Enterprise Data",
        menuIcon: "GM menu item 1.png",
        href: `/${demoId}/chat-bot`,
      },
      {
        id: 12,
        menuName: "Shopping Copilot New",
        menuIcon: "Shopping_Copilot_Icon.png",
        href: `/${demoId}/shopping-copilot-new`,
      },
      {
        id: 3,
        menuName: "Social Media Campaign & Product Recommendation",
        menuIcon: "GM menu item 2.png",
        href: `/${demoId}/social-media-campaign`,
      },
      {
        id: 4,
        menuName: "Azure OpenAI with Speech Service",
        menuIcon: "GM menu item 3.png",
        menuItems: [
          {
            id: 5,
            icon: "icon11_4.png",
            title: "Call Center Report Before - Summary",
            href: `/${demoId}/call-center-before-summary`,
          },
          {
            id: 6,
            icon: "icon11_4.png",
            title: "Call Center Report Before - Script",
            href: `/${demoId}/call-center-before-script`,
          },
          {
            id: 7,
            icon: "icon_video.png",
            title: "Customer Conversation",
            href: `/${demoId}/customer-conversation`,
          },
          {
            id: 8,
            icon: "GM menu item 3.png",
            title: "Call Center - Generate Summary",
            href: `/${demoId}/call-center`,
          },
          {
            id: 9,
            icon: "icon11_4.png",
            title: "Call Center Report After - Script",
            href: `/${demoId}/call-center-after-script`,
          },
          {
            id: 10,
            icon: "icon11_4.png",
            title: "Call Center Report After - Summary",
            href: `/${demoId}/call-center-after-summary`,
          },
        ],
      },
      {
        id: 16,
        menuName: "Shopping Assistant Cosmos",
        menuIcon: "Shopping_Copilot_Icon.png",
        href: `/${demoId}/shopping-assistant-cosmos`,
      },
    ] as Menu[];
  } else if (demoId === CONTOSO_COPILOT_WITH_DASH) {
    return [
      {
        id: 1,
        menuName: "Intro & CEO Dashboard",
        menuIcon: "icon1.png",
        menuItems: [
          {
            id: 2,
            icon: "icon1_2.png",
            title: "Landing Page",
            href: `/${demoId}/landing-page`,
          },
          {
            id: 3,
            icon: "icon1_4.png",
            title: "World Map",
            href: `/${demoId}/world-map`,
          },
          {
            id: 4,
            icon: "icon4_3.png",
            title: "Beach View",
            href: `/${demoId}/city-view`,
          },
          {
            id: 5,
            icon: "icon1_5.png",
            title: "CEO Dashboard - Before",
            href: `/${demoId}/ceo-dashboard-before`,
          },
          {
            id: 6,
            icon: "icon1_3.png",
            title: "ORG Chart",
            href: `/${demoId}/org-chart`,
          },
        ],
      },
      {
        id: 11,
        menuName: "Shopping Copilot",
        menuIcon: "Shopping_Copilot_Icon.png",
        href: `/${demoId}/shopping-copilot`,
      },
      {
        id: 2,
        menuName: "Azure OpenAI Chatbot for Enterprise Data",
        menuIcon: "GM menu item 1.png",
        href: `/${demoId}/chat-bot`,
      },
      // {
      //   id: 12,
      //   menuName: "Shopping Copilot New",
      //   menuIcon: "Shopping_Copilot_Icon.png",
      //   href: `/${demoId}/shopping-copilot-new`,
      // },
      {
        id: 3,
        menuName: "Social Media Campaign & Product Recommendation",
        menuIcon: "GM menu item 2.png",
        href: `/${demoId}/social-media-campaign`,
      },
      {
        id: 4,
        menuName: "Azure OpenAI with Speech Service",
        menuIcon: "GM menu item 3.png",
        menuItems: [
          {
            id: 5,
            icon: "icon11_4.png",
            title: "Call Center Report Before - Summary",
            href: `/${demoId}/call-center-before-summary`,
          },
          {
            id: 6,
            icon: "icon11_4.png",
            title: "Call Center Report Before - Script",
            href: `/${demoId}/call-center-before-script`,
          },
          {
            id: 7,
            icon: "icon_video.png",
            title: "Customer Conversation",
            href: `/${demoId}/customer-conversation`,
          },
          {
            id: 8,
            icon: "GM menu item 3.png",
            title: "Call Center - Generate Summary",
            href: `/${demoId}/call-center`,
          },
          {
            id: 9,
            icon: "icon11_4.png",
            title: "Call Center Report After - Script",
            href: `/${demoId}/call-center-after-script`,
          },
          {
            id: 10,
            icon: "icon11_4.png",
            title: "Call Center Report After - Summary",
            href: `/${demoId}/call-center-after-summary`,
          },
        ],
      },
      {
        id: 16,
        menuName: "CEO Dashboard - After",
        menuIcon: "icon1.png",
        menuItems: [
          {
            id: 17,
            icon: "icon1_5.png",
            title: "CEO Dashboard - After",
            href: `/${demoId}/ceo-dashboard-after`,
          },
          {
            id: 18,
            icon: "icon_video.png",
            title: "Finale Video",
            href: `/${demoId}/finale-video`,
          },
        ],
      },
    ] as Menu[];
  } else if (demoId === CONTOSO_COPILOT_PROD_HARDCODED) {
    return [
      {
        id: 12,
        menuName: "Shopping Copilot",
        menuIcon: "Shopping_Copilot_Icon.png",
        href: `/${demoId}/shopping-copilot-new`,
      },
      {
        id: 2,
        menuName: "Azure OpenAI Chatbot for Enterprise Data",
        menuIcon: "GM menu item 1.png",
        href: `/${demoId}/chat-bot`,
      },
      {
        id: 3,
        menuName: "Social Media Campaign & Product Recommendation",
        menuIcon: "GM menu item 2.png",
        href: `/${demoId}/social-media-campaign`,
      },
      {
        id: 4,
        menuName: "Azure OpenAI with Speech Service",
        menuIcon: "GM menu item 3.png",
        menuItems: [
          {
            id: 5,
            icon: "icon11_4.png",
            title: "Call Center Report Before - Summary",
            href: `/${demoId}/call-center-before-summary`,
          },
          {
            id: 6,
            icon: "icon11_4.png",
            title: "Call Center Report Before - Script",
            href: `/${demoId}/call-center-before-script`,
          },
          {
            id: 7,
            icon: "icon_video.png",
            title: "Customer Conversation",
            href: `/${demoId}/customer-conversation`,
          },
          {
            id: 8,
            icon: "GM menu item 3.png",
            title: "Call Center - Generate Summary",
            href: `/${demoId}/call-center`,
          },
          {
            id: 9,
            icon: "icon11_4.png",
            title: "Call Center Report After - Script",
            href: `/${demoId}/call-center-after-script`,
          },
          {
            id: 10,
            icon: "icon11_4.png",
            title: "Call Center Report After - Summary",
            href: `/${demoId}/call-center-after-summary`,
          },
        ],
      },
    ] as Menu[];
  } else if (FSI_DEMOS.includes(demoId)) {
    return [
      {
        id: 2,
        menuName: "Azure OpenAI Chatbot for Enterprise Data",
        menuIcon: "GM menu item 1.png",
        href: `/${demoId}/chat-bot`,
      },
      {
        id: 3,
        menuName: "Social Media Campaign & Product Recommendation",
        menuIcon: "GM menu item 2.png",
        href: `/${demoId}/social-media-campaign`,
      },
      {
        id: 4,
        menuName: "Azure OpenAI with Speech Service",
        menuIcon: "GM menu item 3.png",
        menuItems: [
          {
            id: 5,
            icon: "icon11_4.png",
            title: "Call Center Report Before - Summary",
            href: `/${demoId}/call-center-before-summary`,
          },
          {
            id: 6,
            icon: "icon11_4.png",
            title: "Call Center Report Before - Script",
            href: `/${demoId}/call-center-before-script`,
          },
          {
            id: 7,
            icon: "icon_video.png",
            title: "Customer Conversation",
            href: `/${demoId}/customer-conversation`,
          },
          {
            id: 8,
            icon: "GM menu item 3.png",
            title: "Call Center - Generate Summary",
            href: `/${demoId}/call-center`,
          },
          {
            id: 9,
            icon: "icon11_4.png",
            title: "Call Center Report After - Script",
            href: `/${demoId}/call-center-after-script`,
          },
          {
            id: 10,
            icon: "icon11_4.png",
            title: "Call Center Report After - Summary",
            href: `/${demoId}/call-center-after-summary`,
          },
        ],
      },
    ];
  } else
    return [
      {
        id: 2,
        menuName: "Azure OpenAI Chatbot for Enterprise Data",
        menuIcon: "GM menu item 1.png",
        href: `/${demoId}/chat-bot`,
      },
      {
        id: 3,
        menuName: "Social Media Campaign & Product Recommendation",
        menuIcon: "GM menu item 2.png",
        href: `/${demoId}/social-media-campaign`,
      },
      {
        id: 4,
        menuName: "Azure OpenAI with Speech Service",
        menuIcon: "GM menu item 3.png",
        menuItems: [
          {
            id: 5,
            icon: "icon11_4.png",
            title: "Call Center Report Before - Summary",
            href: `/${demoId}/call-center-before-summary`,
          },
          {
            id: 6,
            icon: "icon11_4.png",
            title: "Call Center Report Before - Script",
            href: `/${demoId}/call-center-before-script`,
          },
          // {
          //   id: 7,
          //   icon: "icon_video.png",
          //   title: "Customer Conversation",
          //   href: `/${demoId}/customer-conversation`,
          // },
          {
            id: 8,
            icon: "GM menu item 3.png",
            title: "Call Center - Generate Summary",
            href: `/${demoId}/call-center`,
          },
          {
            id: 9,
            icon: "icon11_4.png",
            title: "Call Center Report After - Script",
            href: `/${demoId}/call-center-after-script`,
          },
          {
            id: 10,
            icon: "icon11_4.png",
            title: "Call Center Report After - Summary",
            href: `/${demoId}/call-center-after-summary`,
          },
        ],
      },
      // {
      //   id: 1,
      //   menuIcon: "GM_menu_icon.png",
      //   menuName: "OpenAI Demo",
      //   menuItems: [

      //
      //   ],
      // },
      // {
      //   id: 8,
      //   menuIcon: "header_icon_logout.png",
      //   menuName: "Logout",
      //   href: `/${demoId}/logout`,
      // },
    ] as Menu[];
};
